// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2ojHx","obliqueLineWrap":"membershipbadge_obliqueLineWrap__20Cp2","obliqueLine":"membershipbadge_obliqueLine__28zG3"};